export default __webpack_public_path__ + "static/media/no-test-found.4fe2d8d1.svg";